module.exports = __webpack_public_path__ + "img/maestro_logo.d65e3c0e.svg";